import { render, staticRenderFns } from "./user_list.vue?vue&type=template&id=7b510c57&scoped=true"
import script from "./user_list.vue?vue&type=script&lang=ts"
export * from "./user_list.vue?vue&type=script&lang=ts"
import style0 from "./user_list.vue?vue&type=style&index=0&id=7b510c57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b510c57",
  null
  
)

export default component.exports